import { getApi } from "./api_instance";

export const sideNav = async (dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: "/api/user/sidenav",
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
